@if (isCruiseControlRedesignEnabled) {
  <auto-cruise-control-form-redesign [accountId]="accountId" [settings]="settings" [label]="label" />
} @else {
  <auto-cruise-control-form-legacy [accountId]="accountId" [settings]="settings" [label]="label" />
}
